import { Link } from "react-router-dom";
import { testimonials } from "@/mocks/gossip";

const principles = [
  {
    icon: "ri-shield-check-line",
    title: "公开渠道优先",
    desc: "所有条目整理自公开可见的信息，无法核实的说法会在正文里明确标注为待确认，而不是当作结论。",
  },
  {
    icon: "ri-node-tree",
    title: "分类层级清晰",
    desc: "按频道、版块、栏目三种粒度组织，入口和内容一一对应，翻起来不会跳来跳去。",
  },
  {
    icon: "ri-refresh-line",
    title: "更新及时",
    desc: "热搜与高频版块实时跟进，其余方向每天至少整理一次，入口上直接标出最近更新时间。",
  },
];

export default function BrandSection() {
  return (
    <section id="about" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-12 items-start">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-600 font-medium">
              <i className="ri-bookmark-3-line" />
              关于看料社
            </span>
            <h2 className="mt-2.5 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              把分散的爆料入口收进一个页面
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              看料社做的是同一件事：把公开可见的娱乐爆料版块、频道与栏目整理成结构清楚的入口导航。你不需要记住哪个平台有什么栏目，打开这里按分类点进去就行。
            </p>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们不生产未经编辑的信息，也不对艺人的私人生活下判断。站内的每一条内容，都能在正文里找到整理时间与信息来源类型。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              了解我们的内容原则
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {principles.map((p) => (
              <div key={p.title} className="p-5 rounded-lg bg-background-50 border border-background-200">
                <span className="w-11 h-11 rounded-md flex items-center justify-center text-xl bg-accent-100 text-accent-800">
                  <i className={p.icon} />
                </span>
                <h3 className="mt-4 font-heading font-semibold text-base text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 md:mt-16">
          <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-950 mb-6">
            读者怎么说
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {testimonials.map((t) => (
              <figure key={t.name} className="p-5 rounded-lg bg-background-50 border border-background-200 flex flex-col">
                <div className="w-8 h-8 flex items-center justify-center text-accent-600 text-xl mb-3">
                  <i className="ri-double-quotes-l" />
                </div>
                <blockquote className="text-sm text-foreground-700 leading-relaxed flex-1">{t.quote}</blockquote>
                <figcaption className="mt-4 pt-4 border-t border-background-200 flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full flex items-center justify-center bg-secondary-100 text-secondary-900 text-sm font-medium">
                    {t.name.slice(0, 1)}
                  </span>
                  <span className="flex flex-col leading-tight">
                    <span className="text-sm font-medium text-foreground-900">{t.name}</span>
                    <span className="text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}